import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../assets/images/ri_facebook-fill.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/insta.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/images/ri_youtube-fill.svg";
import { ReactComponent as XIcon } from "../../assets/images/ri_twitter-x-fill.svg";
import Typography from "@mui/material/Typography";
import { Divider, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import styles from "./styles";
import CustomInput from "../../components/CustomInput";
import { loginData } from "../../constants/data";
import { SigninValidate } from "../../helper/Validation";
import { useForm } from "../../hooks/useForm";
// import CircularIndeterminate from "../../utils/Alert/LoginAlert";
import Carousel from "react-material-ui-carousel";
import { LoadingButton } from "@mui/lab";


const LoginPage = ({ handleSignIn, loading }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const Token = localStorage.getItem("accessToken");
    if (Token) {
      navigate("/dashboard");
    }
  }, []);

  const handleLogin = async (data) => {
    // console.log(data,"data");
    handleSignIn(data);
  }
  const { state, handleChange, handleSubmit, handleFocus, disable } = useForm(
    loginData,
    SigninValidate,
    handleLogin,
  );
  const { email, password } = state;

  return (
    <>
      {/* {loading && <CircularIndeterminate />} */}
      <Box sx={styles.main}>
        <Container sx={styles.root}>
          <Paper sx={styles.paper}>

            <Grid container sx={styles.gridContainer}>
              <Grid item xs={12} sm={12} md={6} sx={styles.gridItem}>
                <Box sx={styles.formContain}>
                  <Typography variant="h4" sx={styles.mainheading}>Login to Account</Typography>
                  <Box sx={styles.headingborder}></Box>
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <Box>
                      <Typography sx={styles.inputText}>Email Address</Typography>
                      <CustomInput
                        name="email"
                        value={email?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={email?.error}
 
                      />
                    </Box>
                    <Box>
                      <Box sx={styles.passwordsection}>
                        <Typography sx={styles.inputText}>Password</Typography>
                        <Box sx={styles.forgotpassword}>
                          <Typography><Link to="/forgot-password" style={styles.forgotlinks}>Forgot Password?</Link></Typography>
                        </Box>
                      </Box>
                      <CustomInput
                        name="password"
                        type="password"
                        value={password?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error=""
                      />
                    </Box>
                    <LoadingButton
                      loading={loading}
                      type="submit"
                      fullWidth
                      variant="contained"
                      disabled={disable}
                      sx={styles.submit}
                    > Login
                    </LoadingButton>
                  </form>
                  <Grid container sx={styles.orSection} spacing={{ xs: 3, sm: 3, lg: 10, xl: 10 }} >
                    <Grid item xs={4}>
                      <Divider sx={styles.divider} />
                    </Grid>
                    <Grid item xs={2} container sx={styles.orBox}>
                      <Typography variant="body1" sx={styles.orText}>or</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Divider sx={styles.divider} />
                    </Grid>
                  </Grid>
                  <Box sx={styles.socialIcons}>
                    <a href="https://www.facebook.com/cablinks365" target="_blank" rel="noopener noreferrer">
                      <FacebookIcon style={styles.icon} />
                    </a>
                    <a href="https://www.instagram.com/cablinks365" target="_blank" rel="noopener noreferrer">
                      <InstagramIcon style={styles.icon} />
                    </a>
                    <a href="https://x.com/cablinks" target="_blank" rel="noopener noreferrer">
                      <XIcon style={styles.icon} />
                    </a>
                    <a href="https://www.youtube.com/@cablinks" target="_blank" rel="noopener noreferrer">
                      <YoutubeIcon style={styles.icon} />
                    </a>
                  </Box>
                  <Typography sx={styles.inputText}>Don’t have an account yet? <Link to="/signup" style={styles.forgotlink}>Create Account </Link></Typography>
                  <Box sx={styles.privacyCondition}>
                    <Box>
                      <a href="https://cablinks.org/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                        <Typography sx={styles.termsText}>Privacy</Typography>
                      </a>
                    </Box>
                    <Box sx={styles.greyDot} /><Box>
                      <a href="https://books.cablinks.org/legal/terms" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                        <Typography sx={styles.termsText}>Terms and Conditions</Typography>
                      </a>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              {/* <Hidden xsDown> */}
              <Grid item xs={12} md={6} >
                <Carousel indicators={false}>
                  <Box sx={styles.image}>
                    <Box sx={styles.backgroundImage}></Box>
                    <Typography sx={styles.sliderText}>Ensure the security of your online accounts with 100% security. Safeguard OTP secrets with backup options,
                      guaranteeing access to your accounts.</Typography>
                    <Box sx={styles.dots}>
                      <Box sx={styles.dot2}></Box>
                      <Box sx={styles.dot1}></Box>
                    </Box>
                  </Box>
                  <Box sx={styles.image}>
                    <Box sx={styles.backgroundImage2}></Box>
                    <Typography sx={styles.sliderText}>OTP secrets with backup options,
                      guaranteeing access to your accounts. Ensure the security of your online accounts with 100% security. Safeguard.</Typography>
                    <Box sx={styles.dots}>
                      <Box sx={styles.dot1}></Box>
                      <Box sx={styles.dot2}></Box>
                    </Box>
                  </Box>
                </Carousel>

              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Box >
    </>
  );
}

export default LoginPage;